import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';
import { baseConfig } from './system';
import { foundations } from '../generated/foundations';
import { semanticTokens } from '../generated/semantic';
import { wrapSemanticColors, wrapSemanticRefs, wrapTextStyles } from './utils/to-v3-tokens';

// WCN tenant theme: re-points the brand/status colour scales at other foundation palettes and uses the
// spacious spacing and text styles, layered on the shared base config.
const scaleRef = (colorName: string, scale: Record<string, unknown>) =>
  Object.fromEntries(Object.keys(scale).map(shade => [shade, `${colorName}.${shade}`]));

const wcnColors = wrapSemanticColors({
  brand: scaleRef('navy', foundations.colors.navy),
  info: scaleRef('cyan', foundations.colors.cyan),
  success: scaleRef('jade', foundations.colors.jade),
  warning: scaleRef('orange', foundations.colors.orange),
  error: scaleRef('ruby', foundations.colors.ruby),
  highlight: scaleRef('purple', foundations.colors.purple),
  neutral: scaleRef('ash', foundations.colors.ash),
  'surface-primary': { _light: 'brand.700', _dark: 'brand.700' },
  'surface-primary-hover': { _light: 'brand.800', _dark: 'brand.600' },
  'surface-primary-active': { _light: 'brand.900', _dark: 'brand.500' },
});

const wcnConfig = defineConfig({
  theme: {
    semanticTokens: {
      colors: wcnColors,
      spacing: wrapSemanticRefs(semanticTokens.space.spacious, 'spacing'),
    },
    textStyles: wrapTextStyles(semanticTokens.textStyles.spacious),
  },
});

export const wcn = createSystem(defaultConfig, baseConfig, wcnConfig);
